import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';
import { cerca, crea } from './std';

const {logger} = useBSSLogger();

const strentity = "datiintspe";

const intestazioneById =  async (id) => {

    return cerca(strentity, id)

}

const tipiPersona =  async () => {

    const {data} = await getapiclient().get(`${strentity}/tppers`)

    logger.debug("tipi persona", data);

    return data;  
}

const datiIntestazioneAttiviUtente =  async () => {

    const {data} = await getapiclient().post(`${strentity}/recupera`)

    logger.debug("dati intestazione attivi per utente", data);

    return data;  
}

const datiIntestazioneModifica =  async (dati) => {

    const {data} = await getapiclient().post(`${strentity}/modifica`, {
        elemento: JSON.stringify(dati)
    })

    logger.debug("modifica dati intestazione", data);

    return data;  
}


const datiIntestazioneCrea =  async (dati) => {

    return crea(strentity, dati)
}

const datiIntestazioneOrdini = async () => {
    const {data} = await getapiclient().post(`${strentity}/datiintandorders`)

    logger.debug("nuovo dati intestazione", data);

    return data;  

}

const luogoDaCodiceFiscale = async (codfisc) => {
    const {data} = await getapiclient().post(`tcomuni/dacodicefiscale`)

    logger.debug("luogo da codice fiscale", data);

    return data;  

}


export {intestazioneById, tipiPersona, datiIntestazioneAttiviUtente, datiIntestazioneModifica, datiIntestazioneCrea, datiIntestazioneOrdini, luogoDaCodiceFiscale}